module.exports = __webpack_public_path__ + "static/img/7.8373fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/7.png
// module id = os1O
// module chunks = 0